
import React from 'react';
import { Smartphone, MessageSquare } from 'lucide-react';
import { PropertyField } from '../../molecules/PropertyField';
import { WorkflowNodeData } from '../../../types';

interface SmsTabProps {
    data: WorkflowNodeData;
    onChange: (key: string, value: any) => void;
}

export const SmsTab: React.FC<SmsTabProps> = ({ data, onChange }) => {
    return (
        <div className="p-6 space-y-6">
            <div className="space-y-4">
                 <div className="p-3 bg-indigo-50 dark:bg-indigo-900/20 rounded-lg border border-indigo-100 dark:border-indigo-900 flex gap-3">
                    <Smartphone className="text-indigo-600 dark:text-indigo-400 mt-0.5 shrink-0" size={16} />
                    <div className="space-y-1">
                        <p className="text-xs font-bold text-indigo-800 dark:text-indigo-300">SMS Configuration</p>
                        <p className="text-[11px] text-indigo-700 dark:text-indigo-400 leading-relaxed">
                            Configure outgoing SMS messages. Supports variable interpolation for dynamic content.
                        </p>
                    </div>
                </div>

                 <PropertyField 
                    config={{ name: 'toPhone', label: 'Recipient Phone', type: 'text', placeholder: '+15550001234, ${user.phone}', validation: { required: true }, description: 'E.164 format recommended' }}
                    value={data.toPhone}
                    onChange={onChange}
                />
            </div>

            <hr className="border-slate-200 dark:border-slate-800" />

            <div className="space-y-2">
                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider flex items-center gap-1">
                    <MessageSquare size={12} /> Message Body
                </label>
                
                <textarea 
                    value={data.message || ''}
                    onChange={(e) => onChange('message', e.target.value)}
                    rows={6}
                    maxLength={1600}
                    className="w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500/20 bg-white dark:bg-slate-900 border-slate-300 dark:border-slate-700"
                    placeholder="Hello ${user.name}, your verification code is ${code}."
                />
                <div className="flex justify-end">
                    <span className="text-[10px] text-slate-400">
                        {(data.message?.length || 0)} chars
                    </span>
                </div>
            </div>
        </div>
    );
};